import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable, of} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResultsService {

  constructor(private http: HttpClient) { }
  urlEndPoint = environment.endPoint + "/results";


  getPreviousResults(test, id){
    const params = new URLSearchParams();
    params.set('patientId', id);
    params.set('testRootId', test.testRootId);
    params.set('testRootVersion', test.testRootVersion);
    params.set('testId', test.testId);
    params.set('testVersion', test.testVersion);
    params.set('specimenId', test.specimenId);
    params.set('previousResultsDays', test.previousResultsDays);
    params.set('previousResultsNumber', test.previousResultsNumber);


    return this.http.get<any>(this.urlEndPoint + '/previous-result?' + params.toString());
    
  }
 
}
